import React, { useState } from 'react';
import { IconCheck, IconCopy, IconAlert, IconInfo } from './icons';

function StatusCard({ titulo, protocolo, pin, tipoLabel = 'denúncia' }) {
  const [copiado, setCopiado] = useState(null);

  const copiarParaClipboard = (texto, campo) => {
    navigator.clipboard.writeText(texto);
    setCopiado(campo);
    setTimeout(() => setCopiado(null), 1500);
  };

  return (
    <div className="status-card">
      <div className="status-header">
        <span className="success-icon"><IconCheck /></span>
        <h2>{titulo}</h2>
      </div>

      <div className="status-content">
        <p className="info-message">
          Sua {tipoLabel} foi recebida e registrada com segurança.
          Guarde estas informações para acompanhar o status.
        </p>

        <div className="code-box">
          <div className="code-item">
            <label>Protocolo</label>
            <div className="code-display">
              <code>{protocolo}</code>
              <button
                type="button"
                className="copy-btn"
                onClick={() => copiarParaClipboard(protocolo, 'protocolo')}
                title="Copiar protocolo"
              >
                <IconCopy />
              </button>
            </div>
          </div>

          <div className="code-item">
            <label>PIN</label>
            <div className="code-display">
              <code>{pin}</code>
              <button
                type="button"
                className="copy-btn"
                onClick={() => copiarParaClipboard(pin, 'pin')}
                title="Copiar PIN"
              >
                <IconCopy />
              </button>
            </div>
          </div>
          {copiado && <p className="help-text">Copiado para a área de transferência.</p>}
        </div>

        <div className="warnings">
          <p className="warning"><IconAlert /> Não compartilhe suas informações de acesso com outras pessoas.</p>
          <p className="info"><IconInfo /> Use o protocolo e PIN para acompanhar o andamento.</p>
        </div>
      </div>

      <div className="next-steps">
        <h3>Próximas etapas</h3>
        <ol>
          <li>Você receberá atualizações sobre o andamento</li>
          <li>Você pode acompanhar o status usando protocolo + PIN</li>
        </ol>
      </div>
    </div>
  );
}

export default StatusCard;
